import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import {
  FDBox, FDImage, FDLozenge, FDStack, FDTitleText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import {
  ServiceGroup,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingToolboxTemplate/Layout/ServiceGroup';

const Layout = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  const groups = resource.attr('serviceGroups')?.resources().list() || [];
  return (
    <PageContentContainer>
      <FDStack
        direction={'column'}
        spacing={2}
        alignItems={'center'}
      >
        {resource.withRelationship(fr.relationships.media.name,
          (rel) => <FDImage rounded={false} src={rel.link('related').url()} alt={rel.meta('altText')} />,
          () => null)}
        <PageContentTop
          title={resource.attr('title')}
          subtitle={resource.attr('subtitle')}
        />
        <FDBox paddingY={2}>
          <FDStack
            direction={'column'}
            spacing={1}
            width={'100%'}
          >
            <FDStack
              direction={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
              spacing={2}
              width={'100%'}
            >
              <FDTitleText color={'textSecondary'} value={'Service'} />
              <FDLozenge label={'YOUR PLAN'} color={'info'} size={'lg'} />
            </FDStack>
            <FDStack
              direction={'column'}
              spacing={1}
              width={'100%'}
            >
              {groups.map((group) => (
                <ServiceGroup key={group.id()} group={group} />
              ))}
            </FDStack>
          </FDStack>
        </FDBox>
      </FDStack>
    </PageContentContainer>
  );
};

export { Layout };
